<template>
  <transition name="top" appear>
    <q-page-sticky position="top-right" :offset="[18, 18]">
      <q-btn round outline color="primary" @click="goView" icon="clear">
        <q-tooltip self="center right" anchor="center left" :delay="500">Отменить</q-tooltip>
      </q-btn>
      <q-btn v-if="!type || type === 'd'" round color="warning" @click="doSave" :disabled="notChanged  && type !== 'a'">
        <q-tooltip self="center right" anchor="center left" :delay="500">Сохранить как черновик</q-tooltip>
        <span>&#10003;</span>
        <q-icon name="far fa-file-alt" size="15px"></q-icon>
      </q-btn>
      <q-btn v-else round color="warning" @click="doSave" :disabled="notChanged  && type !== 'a'">
        <q-tooltip self="center right" anchor="center left" :delay="500">Сохранить как черновик</q-tooltip>
        <span>&#10003;</span>
        <q-icon name="far fa-file-alt" size="15px"></q-icon>
      </q-btn>
      <q-btn round color="primary" @click="doPublish" :disabled="notChanged && type !== 'd' && type !== 'v'">
        <q-tooltip self="center right" anchor="center left" :delay="500">Опубликовать</q-tooltip>
        <span>&#10003;</span>
        <q-icon name="fas fa-file-alt" size="15px"></q-icon>
      </q-btn>
    </q-page-sticky>>
  </transition>
</template>
<style>

</style>

<script>

export default {
  name: 'publishBtn',
  props: {
    notChanged: {
      type: Boolean,
      required: true,
    },
    goView: {
      type: Function,
      required: true,
    },
    doSave: {
      type: Function,
      required: true,
    },
    doPublish: {
      type: Function,
      required: true,
    },
    type: {
      type: String,
    },
  },
  components: {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/publish-btn.vue